// 深度洞察：塌房后的粉丝心理机制

export interface Mechanism {
  id: string;
  icon: string;
  title: string;
  lead: string;
  description: string;
  note: string;
}

export const analysisFeatured = {
  kicker: "编辑部手记",
  title: "塌房，是粉丝与偶像之间一场提前终止的承诺",
  deck: "粉丝买的从来不只是作品，更是一种可以依赖的人设承诺。当承诺被证伪，舆论体温的骤降便不再只是吃瓜话题，而是一场大规模的情感合约解除。",
  body: [
    "如果把追星比作一段长期关系，那塌房就是关系里最极端的一种分手方式：没有沟通、没有缓冲，直接由一条爆料触发。粉丝付出的情感、时间与金钱，都以对偶像的信任为前提；当信任这个前提被推翻，过去的投入就会瞬间失去意义。",
    "这也是为什么塌房后的粉丝反应总是又快又猛——脱粉者觉得止损，回踩者要拿回公道，沉默者则努力消化落差。理解这些反应，才能看懂粉圈为何会在七十二小时内剧烈转向。",
  ],
  takeaway: "对公众与行业而言，塌房提醒我们：把人设交给无限信任，往往同时把情绪风险也交给了对方。",
};

export const mechanisms: Mechanism[] = [
  {
    id: "dissonance",
    icon: "ri-bubble-chart-line",
    title: "认知失调与梦碎效应",
    lead: "当'我相信的他'与'爆出来的他'同时存在，大脑会本能地感到痛苦。",
    description:
      "多年建立的正面形象与突如其来的负面形成矛盾，粉丝要么拒绝相信以保护既有认知，要么被迫接受并产生强烈的被背叛感。这种失衡正是脱粉犹豫期与情绪崩溃的根源。",
    note: "延伸思考：认知落差越大，脱粉时机的选择往往越极端。",
  },
  {
    id: "sunkcost",
    icon: "ri-bar-chart-box-line",
    title: "沉没成本与延迟脱粉",
    lead: "投入越多，越难痛快抽身。",
    description:
      "打过的榜、花过的钱、做过的应援，都构成沉没成本。一部分粉丝会因为'已经付出这么多'而选择再给机会、继续观望，这也是为何塌房后仍有人迟迟不肯取关。",
    note: "延伸思考：成本型投入会显著拉长粉丝的决策周期。",
  },
  {
    id: "backlash-psy",
    icon: "ri-emotion-2-line",
    title: "回踩背后的补偿心理",
    lead: "由爱转恨，很多时候是在夺回被辜负的掌控感。",
    description:
      "回踩并非单纯发泄，而是一种重构叙事的尝试：通过晒账目、翻旧料与长篇复盘，把曾经单向付出的自己，重新定义为清醒的、有判断力的一方，以此完成情绪上的自我修复。",
    note: "延伸思考：回踩内容需交叉核实，警惕情绪放大失真。",
  },
  {
    id: "bystander",
    icon: "ri-empathize-line",
    title: "沉默的大多数与路人回流",
    lead: "最响的不是声量，而是悄悄离场的人。",
    description:
      "与高调回踩相比，更多人选择安静取关、不再提及。随着作品开始取代人设被讨论，部分路人以'只看作品'的姿态回流，成为舆论降温后新秩序的一部分。",
    note: "延伸思考：沉默离场与路人回流，往往比声量更能反映基本面。",
  },
];